import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const config = {
    apiKey: "AIzaSyDYx_YqiqLXrdLeIGJiuuTGlqMTUI3skcs",
    authDomain: "compete-14b83.firebaseapp.com",
    projectId: "compete-14b83",
    storageBucket: "compete-14b83.appspot.com",
    messagingSenderId: "578198538858",
    appId: "1:578198538858:web:b301a1a989d377f1a01813",
    measurementId: "G-9KRVBYY51Q"
  };

  const firebase = initializeApp(config);
  const auth = getAuth(firebase)

  export { firebase, auth };